global.conmed = global.conmed || {};

conmed.keyFeatures = function ($) {
    'use strict';
    var that = {
        selectors: {
            slider: '.key-features',
        }
    };

    that.init = function () {

        if (window.matchMedia("(max-width: 768px)").matches) {
            /* the viewport is less than 768 pixels wide */
            $('.key-features-slider').slick({
                dots: true,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
            });
        } 
    };

    return that;
}(jQuery);